const doc = [({"ja":({"adminConstantChargeType":({"perRoom":"部屋課金", "perPerson":"人数課金"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;